import type { SupplierType } from '../services/api';

export const SUPPLIER_TYPE_LABELS: Record<SupplierType, string> = {
  MANUFACTURER: 'Manufacturer',
  DISTRIBUTOR: 'Distributor',
  SUPPLIER: 'Supplier',
  RAW_MATERIALS_SOURCING: 'Raw Materials Sourcing',
  WHOLESALER: 'Wholesaler',
  SERVICE_PROVIDER: 'Service Provider',
  RAW_MATERIAL_SUPPLIER: 'Raw Material Supplier',
  PACKAGING_SUPPLIER: 'Packaging Supplier',
  CONTRACT_MANUFACTURER: 'Contract Manufacturer',
  OIL_SUPPLIER: 'Oil Supplier',
  OTHER: 'Other',
};

export const SUPPLIER_TYPES = Object.entries(SUPPLIER_TYPE_LABELS).map(([value, label]) => ({
  value: value as SupplierType, label,
}));

export const getSupplierTypes = (supplier: { types?: SupplierType[]; type: SupplierType }): SupplierType[] =>
  supplier.types?.length ? supplier.types : [supplier.type];

export const formatSupplierTypes = (supplier: { types?: SupplierType[]; type: SupplierType; customType?: string | null }): string =>
  getSupplierTypes(supplier).map((type) => type === 'OTHER' && supplier.customType
    ? supplier.customType
    : SUPPLIER_TYPE_LABELS[type] || type.replace(/_/g, ' ')).join(', ');
